import React, { useEffect } from "react";

import Lottie from "react-lottie";
import animationData from "assets/json/success.json";

import { Grow, Stack, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "toolkits/redux/auth";

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default function Model({ model }) {
  const {
    id,
    media,
    status,
    address,
    activity,
    is_active,
    tellphone,
    postal_code,
    register_date,
    registered_number,
    national_identifier,
    specialist,
    medical_number
  } = model;
  const dispatch = useDispatch();
  const { userToken } = useSelector((state) => state.auth);

  useEffect(() => {
    status?.id === "4" && dispatch(fetchUser(userToken));
  }, [status]);

  return (
    <>
      <Stack
        overflow="hidden"
        height="calc(100vh - 72px)"
        bgcolor="background.paper"
        justifyContent="space-between"
      >
        <Stack p={1} flexGrow={1} rowGap={2} overflow="scroll">
          <Grow in>
            <Stack py={2} rowGap={2}>
              <Lottie options={defaultOptions} height={300} width={300} />
              <Typography
                align="center"
                variant="subtitle2"
                color="textDisabled"
              >
                {'title'}
              </Typography>
              <Typography align="center" variant="caption" color="textDisabled">
                درخواست شما در حال بررسی است.
                {/* {status?.title} */}
              </Typography>
              <Typography align="center" variant="caption" color="textDisabled">
                کارشناسان ما در کوتاه ترین زمان ممکن به شما پاسخ خواهند داد.
              </Typography>
            </Stack>
          </Grow>
        </Stack>
        <Stack
          p={1}
          py={2}
          columnGap={1}
          alignItems="center"
          direction="row-reverse"
        >
          <Button fullWidth size="large" color="success" variant="contained">
            تماس با پشتیبانی
          </Button>
        </Stack>
      </Stack>
    </>
  );
}
